import React from 'react';
import $ from 'jquery';

/* Profile form component */
class ProfileForm extends React.Component {
  constructor() {
    super()
    this.state = {
      salutation: '',
      fname: '',
      lname: '',
      dob: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      tel: '',
      email: '',
      website: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
    this.checkDate = this.checkDate.bind(this)
  }

  handleSubmit = (e) => {
    $('#update-profile-form').submit(false)
    if (this.state.fname === '' ||
      this.state.lname === '' ||
      this.state.address === '' ||
      this.state.city === '' ||
      this.state.state === '' ||
      this.state.zip === '' ||
      this.state.tel === '' ||
      this.state.email === '') {
      $('#profile-form-msg').text('Please fill in the form')
      return true
    } else if (this.state.fname.length) {
      $('#profile-form-msg').text('Your profile has been updated.')
      e.preventDefault()
      e.stopPropagation()
      return false
    }

  }

  checkDate = (e) => {
    if (e.target.value.substr(0, 4) >= 2017 || e.target.value.substr(0, 4) < 1919) {
      console.error('Invalid date of birth year')
    }
  }

  onChange = (e) => {
    switch (e.target.id) {
      case 'salutation':
        this.setState({ salutation: e.target.value })
        break;
      case 'fname':
        this.setState({ fname: e.target.value })
        break;
      case 'lname':
        this.setState({ lname: e.target.value })
        break;
      case 'dob':
        this.setState({ dob: e.target.value })
        break;
      case 'address':
        this.setState({ address: e.target.value })
        break;
      case 'city':
        this.setState({ city: e.target.value })
        break;
      case 'state':
        this.setState({ state: e.target.value })
        break;
      case 'zip':
        this.setState({ zip: e.target.value })
        break;
      case 'tel':
        this.setState({ tel: e.target.value })
        break;
      case 'email':
        this.setState({ email: e.target.value })
        break;
      case 'website':
        this.setState({ website: e.target.value })
        break;
      default:
        break;
    }
  }

  render() {
    return (
      <form id="update-profile-form" onSubmit={this.handleSubmit}>
        <div className="col-sm-12 col-lg-8 form">
          <div className="row">
            <div className="col-sm-2 form-group">
              <label>Salutation</label>
              <select id="salutation" className="form-control" value={this.state.salutation} onChange={this.onChange}>
                <option value="mr">Mr</option>
                <option value="mrs">Mrs</option>
                <option value="miss">Miss</option>
              </select>
            </div>
            <div className="col-sm-5 form-group">
              <label>First name</label>
              <input type="text" id="fname" placeholder="Jane" className="form-control" value={this.state.fname} onChange={this.onChange} required />
            </div>
            <div className="col-sm-5 form-group">
              <label>Last Name</label>
              <input type="text" id="lname" placeholder="Doe" className="form-control" value={this.state.lname} onChange={this.onChange} required />
            </div>
          </div>
          <div className="form-group col-xs-12 ">
            <label>Date of birth</label>
            <input className="form-control" id="dob" type="date" required onKeyUp={this.checkDate} />
          </div>         
          <div className="form-group">
            <label>Address</label>
            <textarea placeholder="" id="address" rows="3" className="form-control" value={this.state.address} onChange={this.onChange} ></textarea>
          </div>  
          <div className="row">
            <div className="col-sm-4 form-group">
              <label>City</label>
              <input type="text" id="city" placeholder="" className="form-control" required value={this.state.city} onChange={this.onChange}  />
            </div>  
            <div className="col-sm-4 form-group">
              <label>State</label>
              <input type="text" id="state" placeholder="" className="form-control" value={this.state.state} onChange={this.onChange} required />
            </div>  
            <div className="col-sm-4 form-group">
              <label>Zip</label>
              <input type="text" id="zip" placeholder="" className="form-control" value={this.state.zip} onChange={this.onChange}  />
            </div>    
          </div>           
          <div className="form-group">
            <label>Phone Number</label>
            <input type="tel" id="tel" placeholder="xxxx-xxx-xxxx" className="form-control" required value={this.state.tel} onChange={this.onChange} min="6" max="15" />
          </div>    
          <div className="form-group">
            <label>Email Address</label>
            <input type="email" id="email" placeholder="" className="form-control" value={this.state.email} onChange={this.onChange} required />
          </div>  
          <div className="form-group">
            <label>Website</label>
            <input type="text" id="website" placeholder="" className="form-control" value={this.state.website} onChange={this.onChange}  />
          </div>
          <p id="profile-form-msg" className="msg"></p> 
          <button id="btn-submit-profile" type="submit" className="btn btn-default" >Update profile</button>        
          </div>
      </form>
    )
  }
}

// const Salutation = () => {
//   function onSelect() {

//   }
//   return (

//   )
// }

export default ProfileForm


// WEBPACK FOOTER //
// ./src/components/pages/Settings/ProfileForm.js